<template>
  <div>
    <div class="col-12">
      <c-card class="cardClassDetailForm" title="평가 점수 환산표 정보" bgClass="grey-3">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn label="개정" icon="save" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <c-text
              label="제/개정 번호"
              :value="info.col1"
            />
          </div>
          <div class="col-3">
            <c-text
              label="제/개정 일자"
              :value="info.col2"
            />
          </div>
          <div class="col-6">
            <c-text
              label="제/개정 사유"
              :value="info.col3"
            />
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-12">
      <c-table
        ref="table"
        title="평가 점수 환산표 목록"
        tableId="accidentSeq"
        :columns="grid.columns"
        :data="grid.data"
        :usePaging="false"
        :columnSetting="false"
        @linkClick="linkClick"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <div>
            <q-btn-group>
              <c-btn label="항목 추가" icon="add" @btnClicked="addrow" />
              <c-btn v-if="editable" label="저장" icon="save" />
              <c-btn label="삭제" icon="remove" />
            </q-btn-group>
          </div>
        </template>
      </c-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "process-accident",
  data() {
    return {
      info: {
        col1: '1.0',
        col2: '2021-02-21',
        col3: '제정',
      },
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '항목',
            align: 'left',
            type: 'text',
            style: 'width:50%',
            sortable: false
          },
          {
            name: 'col2',
            field: 'col2',
            label: '최고실배점',
            align: 'center',
            type: 'text',
            sortable: false
          },
          {
            name: 'col3',
            field: 'col3',
            label: '환산계수',
            align: 'center',
            type: 'text',
            sortable: false
          },
          {
            name: 'col4',
            field: 'col4',
            label: '최고환산점수',
            align: 'center',
            type: 'text',
            sortable: false
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        search: null,
      },
      editable: true,
      searchUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col1: '안전경영과 근로자참여',
          col2: '370',
          col3: '0.057',
          col4: '21',
        },
        {
          col1: '공정안전자료',
          col2: '70',
          col3: '0.071',
          col4: '5',
        },
        {
          col1: '공정위험성평가',
          col2: '130',
          col3: '0.041',
          col4: '5.5',
        },
        {
          col1: '안전운전 지침과 절차',
          col2: '80',
          col3: '0.05',
          col4: '4',
        },
        {
          col1: '설비의 점검 검사 보수계획, 유지계획 및 지침',
          col2: '120',
          col3: '0.046',
          col4: '5.5',
        },
        {
          col1: '안전작업허가 및 절차',
          col2: '80',
          col3: '0.106',
          col4: '8.5',
        },
        {
          col1: '도급업체 안전관리',
          col2: '100',
          col3: '0.08',
          col4: '8',
        },
        {
          col1: '공정운전에 대한 교육훈련',
          col2: '70',
          col3: '0.071',
          col4: '5',
        },
        {
          col1: '가동전 점검지침',
          col2: '60',
          col3: '0.05',
          col4: '3',
        },
        {
          col1: '변경요소 관리계획',
          col2: '70',
          col3: '0.1',
          col4: '7',
        },
        {
          col1: '자체감사',
          col2: '90',
          col3: '0.044',
          col4: '4',
        },
        {
          col1: '안전사고조사 지침',
          col2: '90',
          col3: '0.033',
          col4: '3',
        },
        {
          col1: '비상조치계획',
          col2: '80',
          col3: '0.044',
          col4: '3.5',
        },
        {
          col1: '현장확인',
          col2: '210',
          col3: '0.081',
          col4: '17',
        },
      ];
    },
  },
};
</script>
